import { useTranslation } from 'react-i18next';

import styles from './back-link.module.scss';

/** Desktop "back": a centered text button under the form. Phones keep the round button at the top-left. */
const BackLink = ({ onClick }: { readonly onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <button type="button" className={styles.back} onClick={onClick}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M15.4 6.6 14 5.2 7.2 12l6.8 6.8 1.4-1.4L10 12z" />
      </svg>
      {t('action.nav_back')}
    </button>
  );
};

export default BackLink;
